export default {
  label: {
    sentimentIndex: 'Sentiment index',
    engagementIndex: 'Engagement index',
  },
};
